<div class="video-layer" [ngClass]="{'inline': inlineBox()}">
	@if (isDevMode()) {
		<div class="w-full h-full bg-gradient-to-br from-lime-600 via-pink-600 to-cyan-600"></div>
	} @else {
		<video [src]="'/videos/bg-02.mov'" autoplay class="background-video" [ngClass]="{'drag-menu-active':(svcMenuBase.svcMenuDrag.menuOpen | async)}" loop muted playsinline></video>
	}
</div>